import { render, staticRenderFns } from "./mask-icon.vue?vue&type=template&id=16884c32&"
import script from "./mask-icon.vue?vue&type=script&lang=js&"
export * from "./mask-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports